import { SET_AUTH_AGENT_FORM_VALUES } from "./types";
import { checkNestedObject } from "utils/checkNestedObject";

export const setAuthAgentFormValues = () => (dispatch, getState) => {
  if (checkNestedObject(getState(), "form", "authAgentInfo", "values")) {
    dispatch({
      type: SET_AUTH_AGENT_FORM_VALUES,
      payload: getState().form.authAgentInfo.values
    });
  }
};
